import { BuyerUserRole } from '@choco-admin/types';

import type { UsersPageBuyerEntityFragmentFragment } from '../../../../generated';

import { BuyerSelectOption } from './types';

export const getSelectOptionFromBuyer = (
  buyer: UsersPageBuyerEntityFragmentFragment,
  role?: string | null
): BuyerSelectOption => ({
  value: buyer.id,
  label: `${buyer.name}-${buyer.referenceId} (${buyer.fullAddress})`,
  metaData: {
    rolesEnabled: buyer.rolesEnabled ?? false,
    buyerUserRole:
      !role || role === BuyerUserRole.DEFAULT
        ? BuyerUserRole.ADMIN
        : (role as BuyerUserRole),
  },
});

export const formatBuyerLabel = (
  name: string,
  referenceId: string,
  fullAddress: string
): string => {
  return `${name}-${referenceId} (${fullAddress})`;
};

// Convert user's linked buyers to BuyerSelectOption format
export const mapUserBuyersToBuyerSelectOptions = (
  userBuyers?: Array<{
    node: {
      id: string;
      name: string;
      referenceId: string;
      fullAddress?: string;
      rolesEnabled?: boolean;
    };
  }>
): BuyerSelectOption[] => {
  if (!userBuyers) {
    return [];
  }

  return userBuyers.map(({ node: buyer }) => ({
    value: buyer.id,
    label: `${buyer.name}-${buyer.referenceId} (${
      buyer.fullAddress || 'No address'
    })`,
    metaData: {
      rolesEnabled: buyer.rolesEnabled ?? false,
      buyerUserRole: BuyerUserRole.ADMIN, // Default role, actual role would need to be fetched separately
    },
  }));
};
